module.exports = __webpack_public_path__ + "img/20200110155609360截图20200110110539143.e75a0a5f.jpg";